import { render, staticRenderFns } from "./ProductSelect.vue?vue&type=template&id=f0f3ef94&scoped=true"
import script from "./ProductSelect.vue?vue&type=script&lang=ts"
export * from "./ProductSelect.vue?vue&type=script&lang=ts"
import style0 from "./ProductSelect.vue?vue&type=style&index=0&id=f0f3ef94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f3ef94",
  null
  
)

export default component.exports